import React from 'react';
import { ReactComponent as FigAlertTriangleComponent } from './FigAlertTriangle.svg';

const FigAlertTriangle = (props) => <FigAlertTriangleComponent {...props} />;

export default FigAlertTriangle;
